import { AxiosResponse } from "axios";

import { microserviceApiAxios } from "../microservice-api.axios";
import { microserviceApiRoutes } from "../microservice-api.routes";
import {
  ICreatePolicyApplianceReq,
  ICreatePolicyApplianceRes,
  IGetApplianceManufacturersRes,
  IGetApplianceQuoteRawRes,
  IGetApplianceQuoteRes,
  IGetDeviceCategoriesRes,
  IPreCreatePolicyPaymentApplianceRes,
} from "./appliances-service.interface";
import { IPolicies } from "../micelu/device/device-service.interface";

export const getDeviceCategories = () => {
  const url = microserviceApiRoutes.v1.agents.appliances.categories();
  return microserviceApiAxios
    .get<Error, AxiosResponse<IGetDeviceCategoriesRes>>(url)
    .then((res) => res.data);
};

export const getApplianceManufacturers = (
  sponsorId: string,
  deviceType?: string,
) => {
  const url = microserviceApiRoutes.v1.agents.appliances.manufacturers();
  return microserviceApiAxios
    .get<
      Error,
      AxiosResponse<IGetApplianceManufacturersRes>
    >(url, { params: { sponsorId, ...(deviceType ? { deviceType } : {}) } })
    .then((res) => res.data);
};

// La respuesta real trae `paymentAmount`/`paymentTaxes` por separado (sin
// `paymentAmountWithTaxes`) y sin `collectedInternally`; se normaliza a
// `IPolicies` (mismo shape que celulares) para reusar el render de planes.
export const getApplianceFreeQuote = (
  sponsorId: string,
  insuredValue: string,
): Promise<IGetApplianceQuoteRes> => {
  const url = microserviceApiRoutes.v1.agents.appliances.quoteFree();
  return microserviceApiAxios
    .get<
      Error,
      AxiosResponse<IGetApplianceQuoteRawRes>
    >(url, { params: { sponsorId, insuredValue } })
    .then((res) => {
      const raw = res.data.data;
      const policies: IPolicies[] = (raw.policies || []).map((policy) => ({
        id: policy.id,
        name: policy.name,
        coverages: policy.coverages,
        pricingOptions: (policy.pricingOptions || []).map((option) => ({
          id: option.id,
          coverageFrequency: option.coverageFrequency,
          paymentAmount: option.paymentAmount,
          paymentAmountWithTaxes:
            option.paymentAmount + (option.paymentTaxes || 0),
          paymentFrequency: option.paymentFrequency,
          paymentQuantity: option.paymentQuantity,
          paymentTaxes: option.paymentTaxes,
          collectedInternally: !!option.collectedInternally,
        })),
      }));
      return { data: { insuredValue: raw.insuredValue, policies } };
    });
};

export const createPolicyAppliance = (data: ICreatePolicyApplianceReq) => {
  const url = microserviceApiRoutes.v1.agents.appliances.policy.create();
  return microserviceApiAxios
    .post<Error, AxiosResponse<ICreatePolicyApplianceRes>>(url, data)
    .then((res) => res.data);
};

export const preCreatePolicyPaymentAppliance = (
  data: ICreatePolicyApplianceReq,
) => {
  const url = microserviceApiRoutes.v1.agents.appliances.policy.pregeneration();
  return microserviceApiAxios
    .post<
      Error,
      AxiosResponse<IPreCreatePolicyPaymentApplianceRes>
    >(url, data)
    .then((res) => res.data);
};
